import React from "react";
import { Grid2, Stack, Typography } from "@mui/material";
import ArticleCard from "./ArticleCard";

interface Props {
  relatedArticles: any;
}

const RelatedArticles = ({ relatedArticles }: Props) => {
  if (relatedArticles.edges.length === 0) {
    return (
      <Stack alignItems="center">
        <Typography sx={{ opacity: 0.5 }}>
          <i>Ingen relaterte artikler funnet</i>
        </Typography>
      </Stack>
    );
  }

  return (
    <Grid2 container justifyContent="center" spacing="40px">
      {relatedArticles.edges.map((article: any, idx: any) => (
        <Grid2 size={{  xs: 12, sm: 6, md: 4}}  key={idx} >
          <ArticleCard article={article.node} />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default RelatedArticles;
